"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("elevate-ui/Button"));

var _withStyles = _interopRequireDefault(require("elevate-ui/withStyles"));

var ButtonRender = function ButtonRender(_ref) {
  var classes = _ref.classes,
      _ref$content = _ref.content,
      attrs = _ref$content.attrs,
      _ref$content$attrs = _ref$content.attrs,
      color = _ref$content$attrs.color,
      url = _ref$content$attrs.url,
      children = _ref$content$attrs.children,
      paddingTop = _ref$content$attrs.paddingTop,
      paddingRight = _ref$content$attrs.paddingRight,
      paddingBottom = _ref$content$attrs.paddingBottom,
      paddingLeft = _ref$content$attrs.paddingLeft,
      fontSize = _ref$content$attrs.fontSize,
      backgroundColor = _ref$content$attrs.backgroundColor,
      isEditor = _ref.internals.isEditor;
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    element: "a",
    href: url,
    color: backgroundColor || "primary",
    onClick: function onClick(e) {
      if (isEditor) {
        e.preventDefault();
      }
    },
    style: {
      paddingTop: paddingTop ? "".concat(paddingTop, "px") : "0",
      paddingRight: paddingRight ? "".concat(paddingRight, "px") : "0",
      paddingBottom: paddingBottom ? "".concat(paddingBottom, "px") : "0",
      paddingLeft: paddingLeft ? "".concat(paddingLeft, "px") : "0",
      margin: "0 auto"
    },
    innerClassName: classes.innerClasses
  }, children);
};

var styles = function styles(theme) {
  return {
    innerClasses: {
      fontSize: function fontSize(props) {
        return props.fontSize;
      },
      color: function color(props) {
        return props.color;
      }
    }
  };
};

var _default = (0, _withStyles["default"])(styles)(ButtonRender);

exports["default"] = _default;